import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=142e226a&scoped=true&"
import script from "./HomePage.vue?vue&type=script&lang=js&"
export * from "./HomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142e226a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('142e226a')) {
      api.createRecord('142e226a', component.options)
    } else {
      api.reload('142e226a', component.options)
    }
    module.hot.accept("./HomePage.vue?vue&type=template&id=142e226a&scoped=true&", function () {
      api.rerender('142e226a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/main/HomePage.vue"
export default component.exports